import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Option } from '../models/option.model';

@Injectable()
export class DataService {
  constructor(private http: HttpClient, private translate: TranslateService) {}

  public getCountries(): Observable<string[]> {
    return this.http.get<string[]>('assets/jsons/countries.json');
  }

  public getSecurityQuestions(): Observable<Option[]> {
    return this.http.get<Option[]>('assets/jsons/securityQuestions.json').pipe(
      map(data => {
        data.forEach(option => (option.text = this.translate.instant(option.text)));
        return data;
      })
    );
  }
}
